class AnimatedScroll {
	constructor(config) {
		this.config = Object.assign({
			scope: '.animated_scroll',
			desktop: {
				stickyStart: 80,
				stackOffset: 50,
			},
			mobile: {
				stickyStart: 80,
				stackOffset: 10,
			},
			breakpoint: 992,
		}, config);

		$(document).ready(() => {
			this.$scope = $(this.config.scope);

			if (this.$scope.length > 0) {
				this.init();
			}
		});
	}

	init() {
		this.$scope.each((_, scope) => {
			const cards = Array.from($(scope).find('[data-animated-scroll-card]'));
			this.#initCards(cards);

			$(window).on('resize.animatedScroll', () => this.#initCards(cards));
		});
	}

	#getConfig() {
		return window.innerWidth >= this.config.breakpoint
			? this.config.desktop
			: this.config.mobile;
	}

	#initCards(cards) {
		const isMobile = window.innerWidth < this.config.breakpoint;
		const { stickyStart, stackOffset } = this.#getConfig();

		cards.forEach((card, i) => {
			if (isMobile) {
				$(card).css({
					position: '',
					top:      '',
					zIndex:   '',
				});
			} else {
				$(card).css({
					position: 'sticky',
					top:      (stickyStart + i * stackOffset) + 'px',
					zIndex:   i + 1,
				});
			}
		});
	}
}

export default new AnimatedScroll;